import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import "@/utils/index.css";
import { createHead } from '@vueuse/head'

const app = createApp(App)

const head = createHead()
app.use(head)
app.use(store)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
